module.exports = __webpack_public_path__ + "static/media/FooterLogos.b2b9149b.svg";